<template>
  <gh-invoke ref="invoke" module="mes.business.mdl.structure.service" cls="StructureService"
    method="get_children_by_function" :args="args">
    <template v-slot="{args,data,loading}">
      <v-layout row align-start justify-start>
        <v-checkbox v-for="item in data" :key="item.Id" :label="item.Name" v-model="item.Checked" color="success"
          @change="checkChanged(item)">
          <template v-slot:label>
            <div class="success--text">{{item.Name}}</div>
          </template>
        </v-checkbox>
      </v-layout>
    </template>
  </gh-invoke>
</template>

<style scoped>

</style>

<script>
  import AreaComponent from "./areaComponent.ts";
  export default AreaComponent;
</script>